/* src/app/warehousing/pages/stock-adjustment/stock-adjustment.component.scss */
/*# sourceMappingURL=stock-adjustment.component.css.map */
